import React, { useEffect } from 'react'
import { Container, FlexColumn } from 'components/common/Containers'
import Progress from 'components/common/Progress/Progress'
import styles from './BulkUploadProgress.module.scss'
import { H6 } from 'components/common/Texts/H6/H6'
import { useGetTaskProgress } from 'hooks/useGetTaskProgress'

interface Props {
  taskID: string
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>
  setTaskID: React.Dispatch<React.SetStateAction<string>>
}

const BulkUploadProgress: React.FC<Props> = ({
  taskID,
  setModalVisible,
  setTaskID,
}) => {
  const { data } = useGetTaskProgress(taskID)

  const currentProgress = data?.progress?.current || 0
  // Close modal when task complete
  useEffect(() => {
    if (data?.complete) {
      setModalVisible(false)
    }
  }, [data?.complete, setModalVisible, setTaskID])

  return (
    <Container>
      <FlexColumn gap="1rem" className={styles.progressColumn}>
        <H6>Hold on while we process the domains</H6>
        <Progress value={currentProgress} className={styles.progress}>
          {currentProgress}%
        </Progress>
      </FlexColumn>
    </Container>
  )
}

export default BulkUploadProgress
